import { toast } from '../../components/ui/toast';

const TZ = 'Asia/Jerusalem';

const dateFmt = new Intl.DateTimeFormat('he-IL', { timeZone: TZ, day: 'numeric', month: 'numeric', year: 'numeric' });
const timeFmt = new Intl.DateTimeFormat('he-IL', { timeZone: TZ, hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
const dtFmt = new Intl.DateTimeFormat('he-IL', { timeZone: TZ, day: 'numeric', month: 'numeric', hour: '2-digit', minute: '2-digit', hour12: false });
const dayFmt = new Intl.DateTimeFormat('he-IL', { timeZone: TZ, weekday: 'short', day: 'numeric', month: 'numeric' });

/** 14.10.2026 */
export function fmtDate(iso: string): string {
  return dateFmt.format(new Date(iso)).replace(/\//g, '.');
}

/** 10:14:02 (today) or 14.10 10:14 (older). */
export function fmtTime(iso: string): string {
  const d = new Date(iso);
  if (Date.now() - d.getTime() < 20 * 3600_000 && dateFmt.format(d) === dateFmt.format(new Date())) return timeFmt.format(d);
  return dtFmt.format(d).replace(/\//g, '.').replace(',', '');
}

export function fmtDateTime(iso: string): string {
  return dtFmt.format(new Date(iso)).replace(/\//g, '.').replace(',', '');
}

/** 'YYYY-MM-DD' (Israel day) -> "ה׳ 14.10" */
export function fmtDay(day: string): string {
  return dayFmt.format(new Date(`${day}T12:00:00Z`)).replace(/\//g, '.').replace(',', '');
}

/** "לפני 3 דק'", "אתמול", "לפני שבוע", "טרם נעשה שימוש". */
export function relTime(iso: string | null): string {
  if (!iso) return 'טרם נעשה שימוש';
  const diff = Math.max(0, Date.now() - new Date(iso).getTime());
  const min = Math.floor(diff / 60_000);
  if (min < 1) return 'עכשיו';
  if (min < 60) return `לפני ${min} דק'`;
  const hrs = Math.floor(min / 60);
  if (hrs < 24) return hrs === 1 ? 'לפני שעה' : hrs === 2 ? 'לפני שעתיים' : `לפני ${hrs} שעות`;
  const days = Math.floor(hrs / 24);
  if (days === 1) return 'אתמול';
  if (days < 7) return `לפני ${days} ימים`;
  if (days < 14) return 'לפני שבוע';
  if (days < 31) return `לפני ${Math.floor(days / 7)} שבועות`;
  return fmtDate(iso);
}

export function fmtNum(n: number): string {
  return n.toLocaleString('he-IL');
}

/** Copy to clipboard + "הועתק" toast. */
export async function copyText(text: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(text);
    toast('הועתק');
  } catch {
    toast('ההעתקה נכשלה. סמנו את הטקסט והעתיקו ידנית', 'error');
  }
}

/** Pill tone for an HTTP status code (mockup: <300 ok, <500 warn, else danger). */
export function codeTone(code: number | null): 'ok' | 'warn' | 'danger' | '' {
  if (code === null) return '';
  return code < 300 ? 'ok' : code < 500 ? 'warn' : 'danger';
}
